<template>
  <b-form-invalid-feedback v-if="form.errors.has(field)" :state="false">
    {{form.errors.get(field)}}
  </b-form-invalid-feedback>
</template>

<script>
import { BFormInvalidFeedback } from 'bootstrap-vue'

export default {
  name: 'input-error',
  props: ['field', 'form'],
  components: {BFormInvalidFeedback}
}
</script>

<style scoped>

</style>
